import { render, staticRenderFns } from "./Registereb.vue?vue&type=template&id=e5dc90a6&scoped=true&"
import script from "./Registereb.vue?vue&type=script&lang=js&"
export * from "./Registereb.vue?vue&type=script&lang=js&"
import style0 from "./Registereb.vue?vue&type=style&index=0&id=e5dc90a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc90a6",
  null
  
)

export default component.exports